/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { IconButton as MuiIconButton, TableCell, Tooltip } from '@material-ui/core';
import ActionsIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import clsx from 'clsx';
import useStyles from '../FOTableBodyStyle';

const ActionCell = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    getActionsTooltipText,
    handleActionMenuClick,
    data,
    cellData,
    anchorActionMenu,
    selectedRow,
    computeActionEntries,
  } = props;

  const actionEntries = computeActionEntries(data);

  return (
    <TableCell align={cellData?.align}>
      {getActionsTooltipText && (
        <Tooltip
          classes={{ tooltip: classes.tooltip }}
          title={getActionsTooltipText()}
          disableHoverListener={actionEntries.length > 0}
        >
          <span>
            <MuiIconButton
              className={clsx(classes.moreIcon, {
                [classes.activeIcon]: selectedRow?.id === data?.id && !!anchorActionMenu,
              })}
              data-testid="action-cell-button"
              aria-label={t(cellData.ariaLabel || 'actions.more')}
              onClick={handleActionMenuClick(data)}
              disabled={actionEntries.length <= 0}
            >
              <ActionsIcon />
            </MuiIconButton>
          </span>
        </Tooltip>
      )}
    </TableCell>
  );
};

export default ActionCell;
